import {
  ActionType,
  IPostConsentStatemenResponse,
  PostConsentStatementPayload,
} from "models/consentStatement/postConsentStatement";

export const postConsentStatementAction = (
  payload: PostConsentStatementPayload
) => {
  return {
    type: ActionType.POST_CONSENT_STATEMENT,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.POST_CONSENT_STATEMENT_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IPostConsentStatemenResponse) => {
  return {
    type: ActionType.POST_CONSENT_STATEMENT_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.POST_CONSENT_STATEMENT_RESET,
  };
};
